import { IonAlert, IonButton, IonCheckbox, IonIcon, IonInput, IonItem, IonLabel, IonTextarea } from '@ionic/react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FieldError, NormalText, SmallText, Spacer, StrongText, Title } from '../../components/common';
import Mobiscroll from '../../components/mobiscroll';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { forwardTo, isWebConfig, validateForm } from '../../lib/utils';
import Layout from '../../components/layout';
import { withRouter } from 'react-router';
import { getConfig } from '../../appConfig';
import FieldWrapper from '../../components/fieldWrapper';
import { calendarOutline, chevronDownOutline, timeOutline } from 'ionicons/icons';
import Modal from '../../components/modal';
import GooglePlacesAutocomplete, { geocodeByPlaceId } from 'react-google-places-autocomplete';
import { getEnv } from '../../lib/env';
import { ReactComponent as EditIcon } from '../../assets/images/edit-icon.svg';
import './index.css';

const { SelectOption, TimePicker } = Mobiscroll;

class GiftVouchers extends Component {
	constructor(props) {
		super(props);
		this.state = {
			giftVoucherValues: [],
			recipient_email: '',
			sender_email: this.props.profile.email || '',
			sender_name: this.props.profile.first_name || '',
			logo_image: this.props.clientProfile.logo_image || '',
			logo_image_light: this.props.clientProfile.logo_image_light || this.props.clientProfile.logo_image || '',
			proceedeToOrderSummaryModalOpen: false,
			postalDelivery: false,
			address: '',
			scriptLoaded: false,
			showAddressFields: this.getPrefillVoucher()?.address || false,
			addressFormatted: '',
			addressValid: true,
			addressData: this.getPrefillVoucher()?.address || null,
			delivery_price: (getConfig().general.giftCardsDeliveryPrice || 0) * 100,
			pickerVisible: false,
			sendMode: this.getInitialSendMode(this.getPrefillVoucher()),
		};
		this.voucherValidator = {
			recipient_email: { type: 'email', required: true },
			sender_email: { type: 'email', required: true },
			sender_name: { type: 'name', required: true },


		};
	}

	getPrefillVoucher = () => this.props.location?.state?.draftVoucher || this.props.location?.state?.voucher;
	getInitialSendMode = (voucher) => {
		if (!voucher) return 'now';
		const isLaterDate = voucher.send_on_date && !moment(voucher.send_on_date, 'MM/DD/YYYY').isSame(moment(), 'day');
		return isLaterDate || voucher.send_on_time ? 'schedule' : 'now';
	};
	isSendOnPassed = () => {
		const voucher = this.props.location?.state?.voucher;
		if (!voucher?.send_on_date) return false;
		return moment(`${voucher.send_on_date} ${voucher.send_on_time || '00:00'}`, 'MM/DD/YYYY HH:mm').isSameOrBefore(moment());
	};
	isScheduled = () => this.state.postalDelivery || this.state.sendMode === 'schedule';
	getSendOnData = () => {
		if (!this.isScheduled()) {
			return { send_on_date: moment().format('MM/DD/YYYY') };
		}
		return {
			send_on_date: this.state.giftVoucherDate,
			...(getConfig().flags.hasTimePickerOnGiftVouchers && this.state.giftVoucherTime && { send_on_time: this.state.giftVoucherTime }),
		};
	};
	loadGoogleMapsScript = () => {
		if (!document.querySelector('#google-maps-script')) {
			const script = document.createElement('script');
			script.id = 'google-maps-script';
			script.src = `https://maps.googleapis.com/maps/api/js?key=${getEnv('GOOGLE_API_KEY')}&libraries=places`;
			script.async = true;
			script.defer = true;
			script.setAttribute('nonce', 'nonce-tU9QXE2MMxqhPUGR')


			script.onload = () => {
				this.setState({ scriptLoaded: true });
				console.log('Google Maps script loaded successfully');
			};

			script.onerror = () => {
				console.error('Error loading Google Maps script');
			};

			document.body.appendChild(script);
		} else {
			this.setState({ scriptLoaded: true });
		}
	};
	componentDidMount() {
		if (getConfig().flags.hasGiftVouchersPostalDelivery) {
			this.loadGoogleMapsScript();

		}
		const voucher = this.getPrefillVoucher();

		this.setState({
			giftVoucherValues: getConfig().general.giftVouchers,
			giftVoucherAmount: getConfig().flags.noDefaultGiftVoucherAmount ? '' : getConfig().general.giftVouchers[1],
		});
		if (voucher) {
			if (this.props.location?.state?.postalDelivery) {
				this.setState({ postalDelivery: true })
			}
			this.setState({
				personal_message: voucher.personal_message,
				recipient_email: voucher.recipient_email,
				recipient_first_name: voucher.recipient_first_name,
				recipient_last_name: voucher.recipient_last_name,
				giftVoucherDate: voucher.send_on_date,
				giftVoucherTime: voucher.send_on_time,
				giftVoucherAmount: voucher.points_value / 100,
				customAmount: !getConfig().general.giftVouchers.some((value) => value == voucher.points_value / 100),
				sender_email: voucher.sender_email || this.props.profile.email,
				sender_name: voucher.sender_name || this.props.profile.first_name || '',
				processing_fee: Basket.getProcessingFee() * 100,

			});
		}
	}
	proceedeToOrderSummary = () => {
		const { recipient_email, sender_email, sender_name, recipient_first_name, recipient_last_name, delivery_price } = this.state;
		const { dispatch, restaurants, profile } = this.props;
		let voucherErrors = validateForm(this.voucherValidator, { recipient_email, sender_email, sender_name, recipient_first_name, recipient_last_name });
		if (this.getAmountError()) {
			voucherErrors.amount = this.getAmountError();
		}
		this.setState({ voucherErrors }, this.scrollToFirstError);
		if (Object.keys(voucherErrors).length === 0) {
			const data = {
				personal_message: this.state.personal_message,
				recipient_email: this.state.recipient_email,
				recipient_first_name: this.state.recipient_first_name,
				recipient_last_name: this.state.recipient_last_name,
				...this.getSendOnData(),
				points_value: Math.round(Number(this.state.giftVoucherAmount) * 100),
				sender_email: this.state.sender_email || this.props.profile.email,
				sender_name: this.state.sender_name,
				address: this.state.addressData,
				delivery_price: 0
			};
			if (this.state.postalDelivery) {
				data.delivery_price = delivery_price
			} else {
			}
			Basket.reset();
			const uuid = `${profile.id}_${Date.now()}`;
			Basket.setUUID(uuid);
			Basket.setCollectionTime(null);
			Basket.setGift(data);
			Basket.addToBasket({
				item: { productPrice: Number(this.state.giftVoucherAmount), productName: 'eGift Voucher', giftVoucherData: data },
				quantity: 1,
				is_gift: true

			});
			Basket.setDeliveryOption({
				id: 'gift-vouchers',
			});

			Basket.setRestaurant(restaurants.find((restaurant) => restaurant.name === 'Vouchers'));
			Basket.setServicePercentage(0);
			dispatch({
				type: 'SET_GIFT_VOUCHER_DATA',
				value: data,
			});
			data.processing_fee = Basket.process_fee_value * 100;
			this.props.history.replace(this.props.location.pathname, { ...this.props.location.state, draftVoucher: data, postalDelivery: this.state.postalDelivery });
			forwardTo('/gift-voucher', {
				voucher: data,
				hasEdit: true,
				postalDelivery: this.state.postalDelivery
			});
		}
	};
	formatVoucherValues = () => {
		const values = this.state.giftVoucherValues;
		const data = values.map((value) => {
			return { text: Basket.formatPrice(value), value };
		});

		return data;
	};
	getDateArray = (obj) => {
		var start = obj.startDate.clone();
		var end = obj.endDate.clone();
		var res = [];
		while (start.isBefore(end)) {
			res.push(start.toDate());
			start.add(1, 'd');
		}
		return res;
	};
	formatDateValues = () => {
		const startDate = moment();
		const endDate = moment().add(30, 'days');
		const daysInBetween = this.getDateArray({ startDate, endDate });
		const data = daysInBetween.map((date) => {
			return {
				text: moment(date).format('DD MMMM YYYY'),
				value: moment(date).format('MM/DD/YYYY'),
			};
		});
		return data;
	};
	handleOnBeforeShow = () => {
		if (!this.state.pickerVisible) {
			this.setState({ pickerVisible: true })
		}
	}
	handleOnBeforeClose = () => {
		if (this.state.pickerVisible) {
			this.setState({ pickerVisible: false })
		}
	}
	getAmountError = () => {
		const { __ } = this.props;
		const amount = Number(this.state.giftVoucherAmount);
		if (this.state.giftVoucherAmount === '' || this.state.giftVoucherAmount == null) return __('Please input a value');
		const customAmountConfig = getConfig().general?.giftVoucherCustomAmount;
		if (this.state.customAmount && customAmountConfig) {
			const { min, max } = customAmountConfig;
			return !Number.isInteger(amount) || amount < min || amount > max ? this.getCustomAmountHint() : null;
		}
		return amount > 0 ? null : __('Please enter a valid amount');
	};
	getCustomAmountHint = () => {
		const { __ } = this.props;
		const { min, max } = getConfig().general.giftVoucherCustomAmount;
		return `${__('Any whole amount from')} ${Basket.formatPrice(min, false, false)} ${__('to')} ${Basket.formatPrice(max, false, false)}`;
	};
	getVoucherValidator = () => ({
		recipient_email: { type: 'email', required: true },
		sender_email: { type: 'email', required: true },
		sender_name: { type: 'name', required: true },
		...(this.state.postalDelivery && {
			recipient_first_name: { type: 'name', required: true },
			recipient_last_name: { type: 'name', required: true },
		}),
	});
	validateField = (field) => {
		const error = field === 'amount' ? this.getAmountError() : validateForm(this.getVoucherValidator(), { [field]: this.state[field] })[field];
		this.setState({ voucherErrors: { ...this.state.voucherErrors, [field]: error || null } });
	};
	validateOnBlur = (field) => (e) => {
		const ionInput = e.target;
		setTimeout(async () => {
			const input = await ionInput.getInputElement();
			if (document.activeElement !== input) this.validateField(field);
		}, 150);
	};
	scrollToFirstError = () => {
		requestAnimationFrame(() => {
			const invalidField = this.formRef?.querySelector('.input-field-wrapper-invalid, .field-error');
			invalidField?.scrollIntoView({ behavior: 'smooth', block: 'center' });
		});
	};
	focusCustomAmountInput = async () => {
		const ionInput = this.customAmountInput;
		if (!ionInput) return;
		await ionInput.componentOnReady?.();
		const input = await ionInput.getInputElement();
		requestAnimationFrame(() => input?.focus());
	};
	shouldComponentUpdate = (nextProps, nextState) => {
		return !nextState.pickerVisible;
	}
	getMinTime = () => {
		const selectedDate = this.state.giftVoucherDate ? moment(this.state.giftVoucherDate, 'MM/DD/YYYY') : moment();
		if (!selectedDate.isSame(moment(), 'day')) {
			return moment().startOf('day');
		}
		const now = moment().startOf('minute');
		return now.add(15 - (now.minute() % 15), 'minutes');
	};
	ensureValidTime = () => {
		if (!getConfig().flags.hasTimePickerOnGiftVouchers) return;
		const minTime = this.getMinTime().format('HH:mm');
		if (!this.state.giftVoucherTime || this.state.giftVoucherTime < minTime) {
			this.setState({ giftVoucherTime: minTime });
		}
	};
	updateGiftVoucher = () => {
		const { recipient_email } = this.state;
		let voucherErrors = validateForm(this.voucherValidator, { recipient_email });
		this.setState({ voucherErrors }, this.scrollToFirstError);
		if (Object.keys(voucherErrors).length === 0) {
			const data = {
				gift_id: this.props.location?.state?.voucher?.id,
				personal_message: this.state.personal_message,
				recipient_email,
				recipient_first_name: this.state.recipient_first_name,
				recipient_last_name: this.state.recipient_last_name,
				...(!this.isSendOnPassed() && this.getSendOnData()),
			};

			this.props.dispatch({
				type: 'UPDATE_GIFT_VOUCHER',
				data,
			});
		}
	};

	resendGiftVoucher = () => {
		const voucher = this.props.location?.state?.voucher;
		this.props.dispatch({
			type: 'RESEND_GIFT_VOUCHER',
			data: {
				gift_id: voucher.id,
				recipient_email: voucher.recipient_email,
				personal_message: voucher.personal_message,
				send_on_date: voucher.send_on_date,
			},
		});
	};

	handleAddressChange = (address) => {
		this.setState({ address, showAddressFields: true }, () => {
			geocodeByPlaceId(address.value.place_id)
				.then((results) => {
					const result = results[0]; // type: google.maps.GeocoderResult
					const components = result.address_components; // type: google.maps.GeocoderAddressComponent[]

					const streetNumberComponent = components.find(el => el.types.includes('street_number'));
					const routeComponent = components.find(el => el.types.includes('route'));
					const postalCodeComponent = components.find(el => el.types.includes('postal_code'));
					const cityComponent =
						components.find(el => el.types.includes('postal_town')) ||
						components.find(el => el.types.includes('locality')) ||
						components.find(el => el.types.includes('administrative_area_level_1')) ||
						components[2];

					// 1. Standard case: street_number + route
					if (streetNumberComponent && routeComponent) {
						const streetNumber = streetNumberComponent.long_name;
						const addressLine1 = `${streetNumber} ${routeComponent.long_name}`;
						this.setState({
							addressValid: true,
							addressFormatted: result.formatted_address,
							addressData: {
								streetNumber: streetNumber,
								addressLine1: addressLine1,
								place: cityComponent?.long_name || '',
								postalCode: postalCodeComponent?.long_name || '',
								lat: result.geometry.location.lat(),
								lng: result.geometry.location.lng(),
								street: routeComponent.long_name
							},
						});
						return;
					}

					// 2. Premise case (e.g. building name instead of street number)
					const premiseComponent = components.find(el => el.types.includes('premise'));
					if (premiseComponent && routeComponent) {
						const addressLine1 = `${premiseComponent.long_name} ${routeComponent.long_name}`;
						this.setState({
							addressValid: true,
							addressFormatted: result.formatted_address,
							addressData: {
								addressLine1: addressLine1,
								place: cityComponent?.long_name || '',
								postalCode: postalCodeComponent?.long_name || '',
								lat: result.geometry.location.lat(),
								lng: result.geometry.location.lng(),
								street: routeComponent.long_name,
							},
						});
						return;
					}

					// 3. Fallback: not enough info, ask user to enter manually
					this.setState({
						address: result.formatted_address,
						addressValid: false,
						isPostCode: false,
						errorMessage: 'The address must include a street number or building name. Please try again.',
						addressData: null,
						showAddressFields: false
					});
				})
				.catch((error) => {
					console.error('Geocoding API Error:', error);
					this.setState({
						addressValid: false,
						isPostCode: false,
						errorMessage: 'There was an error processing the address. Please try again.',
						addressData: null,
						showAddressFields: false
					});
				});
		});
	};
	render() {
		const { __ } = this.props;
		const { address } = this.state
		const dateValues = this.formatDateValues();
		const isSent = this.props.location?.state?.isSent ? true : false;
		const customAmountConfig = getConfig().general?.giftVoucherCustomAmount;
		const voucher = this.props.location?.state?.voucher;
		const isRedeemed = !!voucher?.redeemed_on;
		const title = isRedeemed ? 'Gift voucher' : isSent ? 'Update a gift voucher' : voucher ? 'Edit gift voucher' : 'Send gift voucher';
		return (
			<Layout showHamburger title={__(title)} hideSecondToolbar={true} color="transparent" scrollY={false} backHandler={this.backHandler}>
				<div ref={(el) => (this.formRef = el)} className="absolute-content scrollable-y box-with-shadow">

					<Title className="block page-title-centered">{__(title)}</Title>
					<Spacer size={2} />
					{this.props.clientProfile.gift_voucher_description && <NormalText>{__(this.props.clientProfile.gift_voucher_description)}</NormalText>}
					{getConfig().flags.hasGiftVouchersPostalDelivery && !isSent && <>
						<div className='box-wrapper'>

							<IonItem lines='none' onClick={() => this.setState({ postalDelivery: false })}>
								<IonLabel className="break-space">
									<StrongText>{__('Digital delivery')}</StrongText>
									<Spacer size={0} />
									<SmallText className="block">{__('Send via email')}</SmallText>
									<SmallText className="restaurant-opening-time" >{__('FREE')}</SmallText>

								</IonLabel>
								<IonCheckbox checked={!this.state.postalDelivery} className='round-checkbox' slot="start" color="primary" />
							</IonItem>
							<IonItem lines='none' onClick={() => this.setState({ postalDelivery: true })}>
								<IonLabel className="break-space">
									<StrongText>{__('Postal delivery')}</StrongText>
									<Spacer size={0} />
									<SmallText className="block">{__('Physical card via tracked mail')}</SmallText>
									<SmallText className="restaurant-opening-time" >{this.state.delivery_price == 0 ? __('FREE') : Basket.formatPrice(this.state.delivery_price / 100)}</SmallText>

								</IonLabel>
								<IonCheckbox checked={this.state.postalDelivery} className='round-checkbox' slot="start" color="primary" />
							</IonItem>
						</div>
						<Spacer size={5} />

					</>}
					<div >
						<StrongText>{__('Amount')}</StrongText>
						{!isSent && getConfig().flags.hasGiftVouchersAmountPicker ? (
							!this.state.customAmount && (
								<IonItem lines="none" className="input-field-wrapper dropdown-field">
									<SelectOption
										onBeforeShow={this.handleOnBeforeShow}
										onBeforeClose={this.handleOnBeforeClose}
										theme='ios'
										cssClass={isWebConfig() ? 'web' : ''}
										display="center"
										onSet={(e, a) => this.setState({ giftVoucherAmount: a.getVal(), voucherErrors: { ...this.state.voucherErrors, amount: null } })}
										data={this.formatVoucherValues()}
										label="Location"
										value={this.state.giftVoucherAmount}
										cancelText={__('Cancel')}
										setText={__('OK')}
									/>
									<IonIcon icon={chevronDownOutline} />
								</IonItem>
							)
						) : !isSent && (
							<div className="gift-voucher-amount-pills">
								{this.formatVoucherValues().map(({ text, value }) => (
									<div
										key={value}
										className={'gift-voucher-amount-pill' + (!this.state.customAmount && this.state.giftVoucherAmount == value ? ' selected' : '')}
										onClick={() => this.setState({ giftVoucherAmount: value, customAmount: false, voucherErrors: { ...this.state.voucherErrors, amount: null } })}
									>
										{text}
									</div>
								))}
							</div>
						)}
						{!isSent && !this.state.customAmount && this.state.voucherErrors?.amount && (
							<FieldError className="field-error" value={this.state.voucherErrors.amount} />
						)}
						{isSent || this.state.customAmount ? (
							<div className="gift-voucher-custom-amount">
								<FieldWrapper disabled={isRedeemed} error={this.state.voucherErrors?.amount}>
									<NormalText className={'input-field-floating-text label-color' + (isSent && !isRedeemed ? ' gift-voucher-currency-disabled' : '')}>{Basket.getCurrency().label}</NormalText>
									<IonInput
										ref={(el) => (this.customAmountInput = el)}
										className="custom-amount-field"
										type="number"
										inputmode="numeric"
										disabled={isSent && !isRedeemed}
										value={this.state.giftVoucherAmount}
										placeholder={__('Enter amount')}
										onIonInput={(e) => this.setState({ giftVoucherAmount: e.target.value, voucherErrors: { ...this.state.voucherErrors, amount: null } })}
										onIonBlur={this.validateOnBlur('amount')}
									></IonInput>
									{!isSent && (
										<div
											slot="end"
											className="gift-voucher-custom-amount-cancel normal-text pointer "
											onClick={() => this.setState({ customAmount: false, giftVoucherAmount: getConfig().flags.noDefaultGiftVoucherAmount ? '' : this.state.giftVoucherValues[1], voucherErrors: { ...this.state.voucherErrors, amount: null } })}
										>
											{__('Cancel')}
										</div>
									)}
								</FieldWrapper>
							</div>
						) : customAmountConfig ? (
							<div
								className="centered"
								onClick={() => this.setState({ customAmount: true, giftVoucherAmount: '', voucherErrors: { ...this.state.voucherErrors, amount: null } }, this.focusCustomAmountInput)}
							>
								<Spacer size={2}/>
								<NormalText className='link underlined primary-color'>{__('Custom amount')}</NormalText>
							</div>
						) : null}
						<Spacer size={5}/>
					</div>
					<Title className="block page-title-centered">{__('Recipient details')}</Title>
					<Spacer size={2} />

					{this.state.postalDelivery && <>
						<div className="input-field-container input-field-container-multiple">
							<StrongText className="primary-color">{__('Recipient’s name')}*</StrongText>
							<div>
								<FieldWrapper disabled={isRedeemed} error={this.state.voucherErrors?.recipient_first_name}>
									<IonInput
										placeholder={`${__('First name')}*`}
										onIonInput={(e) => this.setState({ recipient_first_name: e.target.value })}
										onIonBlur={this.validateOnBlur('recipient_first_name')}
										type="text"
										pattern="text"
										inputmode="text"
										value={this.state.recipient_first_name}
										selenium="firstName"
									></IonInput>
								</FieldWrapper>
							</div>
							<div>
								<FieldWrapper disabled={isRedeemed} error={this.state.voucherErrors?.recipient_last_name}>
									<IonInput
										placeholder={`${__('Last name')}*`}
										onIonInput={(e) => this.setState({ recipient_last_name: e.target.value })}
										onIonBlur={this.validateOnBlur('recipient_last_name')}
										type="text"
										pattern="text"
										inputmode="text"
										value={this.state.recipient_last_name}
										selenium="lastName"
									></IonInput>
								</FieldWrapper>

							</div>
						</div>
					</>}
					<div className="input-field-container">
						<StrongText>{__('Recipient’s email address')}*</StrongText>
						<FieldWrapper disabled={isRedeemed} error={this.state.voucherErrors?.recipient_email}>
							<IonInput
								onIonInput={(e) => this.setState({ recipient_email: e.target.value })}
								onIonBlur={this.validateOnBlur('recipient_email')}
								type="email"
								pattern="email"
								inputmode="email"
								value={this.state.recipient_email}
								placeholder={__('Recipient email address')}
							></IonInput>
						</FieldWrapper>

					</div>
					<div className="input-field-container">
						<StrongText>{__('Enter a personal message')}</StrongText>

						<IonItem lines="none" className={'input-field-wrapper' + (isRedeemed ? ' disabled-wrapper' : '')}>
							<IonTextarea
								rows={5}
								placeholder={__('Your message')}
								onIonInput={(e) => this.setState({ personal_message: e.target.value })}
								value={this.state.personal_message}
							></IonTextarea>
						</IonItem>
					</div>

					{this.state.postalDelivery && <>
						<Title className="block page-title-centered">{__('Delivery details')}</Title>
						<Spacer size={2} />
						{this.state.scriptLoaded &&
							<>
								<StrongText>{__('Where should we send the gift voucher?')}</StrongText>
								<Spacer size={2} />
								{!this.state.showAddressFields ? <>

									<div className="input-field-container">
										<FieldWrapper error={this.state.voucherErrors?.address}>
											<GooglePlacesAutocomplete
												autocompletionRequest={{
													componentRestrictions: {
														country: [getConfig().general.defaultState || 'UK'],
													},
												}}
												selectProps={{
													placeholder: `${__('Select the address')}`,
													value: this.state.address,
													onChange: this.handleAddressChange,
													menuPortalTarget: document.body,

													noOptionsMessage: () => {
														return __('No options available');
													},
													styles: {
														control: (provided, state) => ({
															...provided,
															backgroundColor: 'transparent',
															borderColor: 'transparent !important',
															outline: "none !important",
															boxShadow: 'none !important'

														}),
														input: (provided) => ({
															...provided,
															outline: "none !important",
															borderColor: 'transparent !important',
														}),
														singleValue: (provided) => ({
															...provided,
															outline: "none !important",
															borderColor: 'transparent !important',
															color: 'var(--okx-textfield-color)'
														}),
														option: (provided, state) => ({
															...provided,
															cursor: 'pointer',
														}),
														container: (provided, state) => ({
															...provided,
															width: '100%',
															outline: "none !important",
															borderColor: 'transparent !important',
														}),
													},
												}}
											/>
										</FieldWrapper>
									</div>

								</> : <>
									<div className='flex flex-col-wrapper flex-justify-between'>
										<StrongText>{__('Address:')}</StrongText>
										{!isRedeemed && <EditIcon className='fill-text' style={{ margin: 0 }} onClick={() => this.setState({ showAddressFields: false, address: '' })} />}
									</div>
									<Spacer size={0} />
									<NormalText>{this.state.addressData?.addressLine1}</NormalText>
									<NormalText>{this.state.addressData?.place}</NormalText>
									<NormalText>{this.state.addressData?.postalCode}</NormalText>
									<Spacer size={5} />
								</>

								}
							</>

						}
					</>}
					{!this.isSendOnPassed() && (
					<div className="input-field-container">
						<StrongText style={this.state.postalDelivery ? { marginBottom: 0 } : null}>{this.state.postalDelivery ?`${__('When should the gift voucher arrive?')}*` : __('When shall we send the voucher?')}</StrongText>
						{!this.state.postalDelivery && (
							<div className={'gift-voucher-send-mode' + (this.state.sendMode === 'schedule' ? ' schedule' : '') + (isRedeemed ? ' disabled-wrapper' : '')}>
								{[
									{ mode: 'now', label: __('Send now') },
									{ mode: 'schedule', label: __('Schedule') },
								].map(({ mode, label }) => (
									<div
										key={mode}
										className={'gift-voucher-send-mode-option' + (this.state.sendMode === mode ? ' selected' : '')}
										onClick={() => this.setState({ sendMode: mode })}
									>
										{label}
									</div>
								))}
							</div>
						)}
									{this.isScheduled() && (
					<div className="gift-voucher-schedule-row">
					<div className="input-field-container gift-voucher-date-field">
						<IonItem lines="none" className={'input-field-wrapper' + (isRedeemed ? ' disabled-wrapper' : '')}>
							<IonIcon icon={calendarOutline} className="gift-voucher-picker-icon" />
							<SelectOption
								onBeforeShow={this.handleOnBeforeShow}
								onBeforeClose={this.handleOnBeforeClose}
								theme='ios'
								cssClass={isWebConfig() ? 'web' : ''}

								display="center"
								onSet={(e, a) => this.setState({ giftVoucherDate: a.getVal() }, this.ensureValidTime)}
								data={dateValues}
								label="Location"
								value={this.state.giftVoucherDate}
								cancelText={__('Cancel')}
								setText={__('OK')}
								onInit={() => {
									if (!this.state.giftVoucherDate) {
										this.setState({ giftVoucherDate: dateValues[0].value }, this.ensureValidTime);
									} else {
										this.ensureValidTime();
									}
								}}
							/>
						</IonItem>
					</div>
					{getConfig().flags.hasTimePickerOnGiftVouchers && (
						<div className="input-field-container gift-voucher-time-field">
							<IonItem lines="none" className={'input-field-wrapper' + (isRedeemed ? ' disabled-wrapper' : '')}>
								<IonIcon icon={timeOutline} className="gift-voucher-picker-icon" />
								<TimePicker
									onBeforeShow={this.handleOnBeforeShow}
									onBeforeClose={this.handleOnBeforeClose}
									theme='ios'
									cssClass={`${isWebConfig() ? 'web' : ''} vouchers-time-picker-wrapper`}
									display="center"
									timeFormat="HH:ii"
									focusOnClose={false}
									steps={{ minute: 15 }}
									min={this.getMinTime().toDate()}
									value={this.state.giftVoucherTime ? moment(this.state.giftVoucherTime, 'HH:mm').toDate() : null}
									placeholder={__('Select time')}
									onSet={(e, a) => this.setState({ giftVoucherTime: moment(a.getVal()).format('HH:mm') })}
									cancelText={__('Cancel')}
									setText={__('OK')}
								/>
							</IonItem>
						</div>
					)}
					</div>
					)}
					</div>
					)}

					{this.state.postalDelivery &&
						<>
							<StrongText>{__('Delivery information')}</StrongText>
							<Spacer size={2} />

							<NormalText>• {__('Royal Mail 48 hour tracked delivery')}</NormalText>
							<NormalText>• {__('Dispatched to arrive on the date specified')}</NormalText>
							<NormalText>• {__('Delivery date is not guaranteed')}</NormalText>
							<NormalText>• {__('Tracking number provided via email')}</NormalText>
							<Spacer size={5} />

						</>
					}
					<Title className="block page-title-centered">{__('Your details')}</Title>
					<Spacer size={2} />
					<div className="input-field-container">
						<StrongText>{__('Your name (sender)')}*</StrongText>
						<FieldWrapper disabled={isRedeemed} error={this.state.voucherErrors?.sender_name}>
							<IonInput
								onIonInput={(e) => this.setState({ sender_name: e.target.value })}
								onIonBlur={this.validateOnBlur('sender_name')}
								type="text"
								pattern="text"
								inputmode="text"
								value={this.state.sender_name}
								placeholder={__("Sender's name")}
							></IonInput>

						</FieldWrapper>

					</div>
					<div className="input-field-container">
						<StrongText>{__('Your email address (sender)')} *</StrongText>
						<FieldWrapper disabled={isRedeemed || this.props.auth.loggedIn} error={this.state.voucherErrors?.sender_email}>
							<IonInput
								onIonInput={(e) => this.setState({ sender_email: e.target.value })}
								onIonBlur={this.validateOnBlur('sender_email')}
								type="email"
								pattern="email"
								inputmode="email"
								value={this.state.sender_email}
								placeholder={__("Sender's email address")}
							></IonInput>
						</FieldWrapper>
					</div>

					<Spacer size={2} />
					{isRedeemed ? null : isSent ? (
						<>
							<IonButton className='button-uppercase' disabled={this.state.recipient_email.length === 0} onClick={(e) => { e.target.focus(); this.updateGiftVoucher() }} color="primary" expand="block">
								{__('Update gift voucher')}
							</IonButton>
							{voucher?.is_sent && (
								<>
								<Spacer size={2}/>
								<IonButton className='button-uppercase' fill="outline" color="primary" expand="block" onClick={this.resendGiftVoucher}>
									{__('Resend gift voucher')}
								</IonButton>
							</>
							)}
						</>
					) : (
						<IonButton
							className='button-uppercase'
							disabled={this.state.recipient_email.length === 0}
							onClick={() => {
								if (voucher) {
									this.proceedeToOrderSummary();
								} else {
									if (this.state.postalDelivery) {
										this.voucherValidator = {
											...this.voucherValidator,
											recipient_first_name: { type: 'name', required: this.state.postalDelivery },
											recipient_last_name: { type: 'name', required: this.state.postalDelivery },

										}
									} else {
										this.voucherValidator = {
											recipient_email: { type: 'email', required: true },
											sender_email: { type: 'email', required: true },
											sender_name: { type: 'name', required: true },
										};
									}
									let voucherErrors = validateForm(this.voucherValidator, { recipient_email: this.state.recipient_email, sender_email: this.state.sender_email, sender_name: this.state.sender_name, recipient_first_name: this.state.recipient_first_name, recipient_last_name: this.state.recipient_last_name });
									if (this.state.postalDelivery && !this.state.addressData) {
										voucherErrors.address = __('Required field')
									}
									if (this.getAmountError()) {
										voucherErrors.amount = this.getAmountError()
									}
									this.setState({ voucherErrors }, () => {

										if (Object.keys(voucherErrors).length === 0) {
											if (this.state.postalDelivery) {
												Basket.setDeliveryAddress(this.state.addressData, false)
											}
											this.setState({ proceedeToOrderSummaryModalOpen: true });

										} else {
											this.scrollToFirstError();
										}
									});


								}
							}}
							color="primary"
							expand="block"
						>
							{voucher ? __('Confirm') : __('Continue')}
						</IonButton>
					)}
				</div>
				<Modal
					className={`modal-type-alert`}
					isOpen={this.state.proceedeToOrderSummaryModalOpen}
					onDidDismiss={() => this.setState({ proceedeToOrderSummaryModalOpen: false })}
				>
					<div style={{ textAlign: 'center', display: 'grid', justifyItems: 'center' }}>
						{this.state.postalDelivery ?
							<>
								<StrongText className='centered block'>{__('Check the delivery address')}</StrongText>
								<Spacer size={1} />

								<NormalText>{this.state.addressData?.addressLine1}</NormalText>
								<NormalText>{this.state.addressData?.place}</NormalText>
								<NormalText>{this.state.addressData?.postalCode}</NormalText>
								<Spacer size={5} /></>
							:
							<>
								<Spacer size={5} />
								<StrongText className='centered block'>{__('Confirm your email')}</StrongText>
								<Spacer size={1} />
								<NormalText className='centered block text-to-update'>{`${__('Your voucher confirmation will be sent to the following email address:')} ${this.state.sender_email}`}</NormalText>
								<Spacer size={5} /></>
						}


					</div>
					<IonButton className='button-uppercase' expand="block" onClick={() => this.proceedeToOrderSummary()}>
						{__('OK')}
					</IonButton>
					<Spacer size={2} />
					<IonButton expand="block" color='secondary' className='link' onClick={() => this.setState({ proceedeToOrderSummaryModalOpen: false })}>
						{__('Cancel')}
					</IonButton>
				</Modal>
			</Layout>
		);
	}
}

const stateToProps = (state) => {
	return {
		sentGiftVouchers: state.orders.sentGiftVouchers || [],
		redeemedGiftVoucher: state.orders.redeemedGiftVoucher || null,
		auth: state.profile.auth,
		navConfig: state.common.navConfig,
		clientProfile: state.common.clientProfile,
		clientStyles: state.common.clientStyles,
		profile: state.profile.profile,
		restaurants: state.restaurants.restaurants || [],
	};
};

const ConnectedGiftVouchers = withTranslation(connect(stateToProps)(GiftVouchers));

export default withRouter((props) => <ConnectedGiftVouchers key={props.location.key} {...props} />);
